var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

(function (mod){ //[HyperMD] UMD patched!
  /*commonjs*/  ("object"==typeof exports&&"undefined"!=typeof module) ? mod(null, exports, require("../../addon/block-info/index")) :
  /*amd*/       ("function"==typeof define&&define.amd) ? define(["require","exports","../../addon/block-info/index"], mod) :
  /*plain env*/ mod(null, (this.HyperMD.PreviewFeatureFence = this.HyperMD.PreviewFeatureFence || {}), HyperMD.BlockInfoAddon);
})(function (require, exports, index_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.unescapeString = exports.escapeString = void 0;
    var TAGS_TO_REPLACE = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#x27;",
        "/": "&#x2F;",
        "\\": "&#x5C;"
    };
    var TAGS_TO_REPLACE_REVERSE = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&apos;": "'",
        "&#x27;": "'",
        "&#x2F;": "/",
        "&#x5C;": "\\"
    };
    function escapeString(str) {
        if (str === void 0) { str = ""; }
        return str.replace(/[&<>"'\/\\]/g, function (tag) { return TAGS_TO_REPLACE[tag] || tag; });
    }
    exports.escapeString = escapeString;
    function unescapeString(str) {
        if (str === void 0) { str = ""; }
        return str.replace(/\&(amp|lt|gt|quot|apos|\#x27|\#x2F|\#x5C)\;/g, function (whole) { return TAGS_TO_REPLACE_REVERSE[whole] || whole; });
    }
    exports.unescapeString = unescapeString;
    var ensureClassInAttributes = function (attributes, className) {
        var _a;
        var existingClassNames = attributes["class"] || "";
        if (existingClassNames.split(" ").indexOf(className) === -1) {
            return __assign(__assign({}, attributes), (_a = {}, _a["class"] = (existingClassNames + " " + className).trim(), _a));
        }
    };
    exports.default = (function (md) {
        md.renderer.rules.fence = function (tokens, idx, options, env, instance) {
            var token = tokens[idx];
            // get code info (same line as opening fence)
            var info = token.info.trim();
            var parsedInfo = index_1.parseBlockInfo(info);
            var normalizedInfo = index_1.normalizeBlockInfo(parsedInfo);
            // get code content
            var content = escapeString(token.content);
            // copied from getBreak function.
            var finalBreak = idx < tokens.length && tokens[idx].type === "list_item_close" ? "\n" : "";
            // Check diagrams
            // https://github.com/shd101wyy/mume/blob/eb0f4107ee98505e8b5751d486f8c061c3b939b5/src/render-enhancers/fenced-diagrams.ts
            if (parsedInfo.language === "mermaid") {
                return "<div class=\"vickeymd-fence " + parsedInfo.language + "\" data-parsed-info=\"" + escapeString(JSON.stringify(parsedInfo)) + "\" data-normalized-info=\"" + escapeString(JSON.stringify(normalizedInfo)) + "\">" + content + "</div>";
            }
            else if (parsedInfo.language === "wavedrom") {
                return "<div class=\"vickeymd-fence " + parsedInfo.language + "\" data-parsed-info=\"" + escapeString(JSON.stringify(parsedInfo)) + "\" data-normalized-info=\"" + escapeString(JSON.stringify(normalizedInfo)) + "\"><script type=\"WaveDrom\">" + token.content + "</script></div>";
            }
            return "<pre data-role=\"codeBlock\" class=\"vickeymd-fence\" data-info=\"" + escapeString(info) + "\" data-parsed-info=\"" + escapeString(JSON.stringify(parsedInfo)) + "\" data-normalized-info=\"" + escapeString(JSON.stringify(normalizedInfo)) + "\">" + content + "</pre>" + finalBreak;
        };
    });
});
